<template>
    <div>
        <v-card class="mt-8 mx-8 pa-4">
            <v-card-actions class="text-left">
                <v-row>
                    <v-col cols="12" class="text-left">
                        <v-icon class="back-link-icon" x-large @click="$router.push('/cover/index')">mdi-arrow-left
                        </v-icon>
                    </v-col>
                </v-row>
            </v-card-actions>
            <v-card-title>ساخت کاور جدید</v-card-title>
            <v-card-text>
                <v-row>
                    <v-col cols="6" md="3" lg="3" sm="6">
                        <v-text-field color="black" v-model="cover.tag" label="تگ کاور"></v-text-field>
                    </v-col>
                    <v-col cols="3">
                        <v-text-field label="کاور"
                                      @click="openFileDialog()" prepend-icon="mdi-plus"
                                      color="black"
                                      v-model="cover.url"></v-text-field>
                    </v-col>

                    <v-col cols="3" md="3" lg="3" sm="6">
                        <v-select label="نوع کاور"
                                  :items="[{text:'دوره',value:'course'},{text:'درس ها',value:'item'},{text:'فایل ها',value:'item_file'}]"
                                  color="black" v-model="cover.type">
                        </v-select>
                    </v-col>
                    <v-col cols="6" class="text-center">
                        <v-btn block color="success" class="normal-font-btn" @click="store()">ذخیره</v-btn>
                    </v-col>
                    <v-col cols="6" class="text-center">
                        <v-btn block color="warning" class="normal-font-btn" @click="clear()">پاک کردن</v-btn>
                    </v-col>
                </v-row>
            </v-card-text>
        </v-card>
        <v-dialog v-model="uploadFileDialog" max-width="50vw">
            <drag-and-drop module="cover" ref="image-uploader" @closeUploadFileDialog="uploadFileDialog = false"
                           @changeFile="cover.url = $event"></drag-and-drop>
        </v-dialog>
    </div>
</template>

<script>
import DragAndDrop from "@/components/UploadFile/DragAndDrop";

export default {
    name: "CoverCreateView",
    components: {DragAndDrop},
    data() {
        return {
            uploadFileDialog: false,
            cover: {
                tag: null,
                url: null,
                type: null,
            }
        }
    },
    mounted() {
    },
    methods: {
        store() {
            window.axios.post('file-manager/cover/create', this.cover).then(() => {
                this.openSnackbar("کاور جدید با موفقیت ساخته شد.", 'success')
            }).catch((err) => {
                if (err.response.status === 422) {
                    this.showValidationErrors(err, '#F1416C')
                } else if (err.response.status === 400) {
                    this.openSnackbar(err.response.data.message, '#F1416C')
                }
            })
        },
        clear() {
            this.cover = {
                tag: null,
                url: null,
                type: null,
            }
        },
        openFileDialog() {
            this.uploadFileDialog = true
        },
    }
}
</script>

<style>
.back-link-icon {
    color: #413e3e !important;
}

.back-link-icon:hover {
    color: orangered !important;
}

.normal-font-btn {
    letter-spacing: normal !important;
}
</style>